import { TableTextCell } from '../TableTextCell'

import { formatFloat } from './TableFloatCell.utils'

function TableFloatCell({ value, ...cellProps }) {
  return <TableTextCell {...cellProps} value={formatFloat(value)} />
}

export default TableFloatCell
